import { Navigate } from 'react-router-dom'
import { defaultPathForRole, useAuth } from '@/lib/auth'

/** Landing del layout `/app` — redirige al home del rol actual. */
export function AppRedirect() {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  return <Navigate to={defaultPathForRole(user.role)} replace />
}
